import { FC, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/messages';
import { translate } from 'containers/services/translate';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';

export interface ActionButtonProps {
  intl: IntlShape;
  handleOpenDialogValidation: Function;
  handleOpenDialogRejection: Function;
  shouldDisplayAppreciation: boolean;
  isTransaction?: boolean;
  isImportedExpertise?: boolean;
  handleOpenAppreciationDialog?: Function;
  shouldDisplayOnlyAppreciation?: boolean;
}

export const ActionButton: FC<ActionButtonProps> = props => {
  const [dropDown, setDropDown] = useState<null | HTMLElement>(null);
  const dropDownMenuElements = props.shouldDisplayOnlyAppreciation
    ? [
        {
          title: translate(messages.appreciationTitle, props),
          action: /* istanbul ignore next */ () =>
            props.handleOpenAppreciationDialog &&
            props.handleOpenAppreciationDialog(),
        },
      ]
    : props.shouldDisplayAppreciation &&
      props.handleOpenAppreciationDialog &&
      props.isImportedExpertise &&
      props.isTransaction
    ? [
        {
          title: translate(messages.validateTitle, props),
          action: /* istanbul ignore next */ () =>
            props.handleOpenDialogValidation(),
        },
        {
          title: translate(messages.appreciationTitle, props),
          action: /* istanbul ignore next */ () =>
            props.handleOpenAppreciationDialog &&
            props.handleOpenAppreciationDialog(),
        },
      ]
    : props.shouldDisplayAppreciation &&
      props.handleOpenAppreciationDialog &&
      !props.isImportedExpertise &&
      !props.isTransaction
    ? [
        {
          title: translate(messages.validateTitle, props),
          action: /* istanbul ignore next */ () =>
            props.handleOpenDialogValidation(),
        },
        {
          title: translate(messages.rejectTitle, props),
          action: /* istanbul ignore next */ () =>
            props.handleOpenDialogRejection(),
        },
        {
          title: translate(messages.appreciationTitle, props),
          action: /* istanbul ignore next */ () =>
            props.handleOpenAppreciationDialog &&
            props.handleOpenAppreciationDialog(),
        },
      ]
    : props.shouldDisplayAppreciation &&
      props.handleOpenAppreciationDialog &&
      !props.isImportedExpertise &&
      props.isTransaction
    ? [
        {
          title: translate(messages.validateTitle, props),
          action: /* istanbul ignore next */ () =>
            props.handleOpenDialogValidation(),
        },
        {
          title: translate(messages.rejectTitle, props),
          action: /* istanbul ignore next */ () =>
            props.handleOpenDialogRejection(),
        },
        {
          title: translate(messages.appreciationTitle, props),
          action: /* istanbul ignore next */ () =>
            props.handleOpenAppreciationDialog &&
            props.handleOpenAppreciationDialog(),
        },
      ]
    : !props.shouldDisplayAppreciation &&
      props.handleOpenAppreciationDialog &&
      props.isImportedExpertise &&
      props.isTransaction
    ? [
        {
          title: translate(messages.validateTitle, props),
          action: /* istanbul ignore next */ () =>
            props.handleOpenDialogValidation(),
        },
      ]
    : [
        {
          title: translate(messages.validateTitle, props),
          action: () => props.handleOpenDialogValidation(),
        },
        {
          title: translate(messages.rejectTitle, props),
          action: () => props.handleOpenDialogRejection(),
        },
      ];
  return (
    <DropDownDecisionMenu
      setDropDown={setDropDown}
      dropDown={dropDown}
      label={translate(messages.managerActionTitle, props)}
      menuElements={dropDownMenuElements}
    />
  );
};

export default injectIntl(ActionButton);
